export const flexTheme = {
  baseStyle: {},
  sizes: {},
  variants: {
    sessionContent: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  defaultProps: {},
}
